<template>
  <div>
    <horizontal-field-layout
      label="送信日"
    >
      <div class="flex">
        <template v-if="readOnly">
          <div class="flex mt-1">
            <div>出荷後から</div>
            <div class="mx-2">
              {{ innerDay }}
            </div>
            <div>日後</div>
          </div>
        </template>
        <template v-else>
          <div class="mr-2 mt-1">
            出荷後から
          </div>
          <input-field
            v-model.number="innerDay"
            name="送信日"
            class="mr-2"
            min="7"
            max="30"
            type="number"
          />
          <div class="mt-1">
            日後
          </div>
        </template>
      </div>
    </horizontal-field-layout>
    <horizontal-field-layout
      class="mt-8"
      label="送信時間"
    >
      <template v-if="readOnly">
        <div class="mt-1">
          {{ `${innerHour}: 00` }}
        </div>
      </template>
      <template v-else>
        <select-field
          v-model="innerHour"
          name="送信時間"
          :options="hours"
        />
      </template>
    </horizontal-field-layout>
    <horizontal-field-layout
      class="mt-8"
      label="有効"
    >
      <template v-if="readOnly">
        <switch-field
          class="mt-1"
          :model-value="innerEnabled"
        />
      </template>
      <template v-else>
        <switch-field
          v-model="innerEnabled"
          class="mt-2"
          name="有効"
        />
      </template>
    </horizontal-field-layout>
  </div>
</template>

<script>
import SelectField from '@/components/fields/SelectField'
import HorizontalFieldLayout from '@/components/layouts/form/HorizontalFieldLayout'
import InputField from '@/components/fields/InputField'
import SwitchField from '@/components/fields/SwitchField'

export default {
  name: 'ReviewRequestForm',
  components: {
    SwitchField,
    InputField,
    HorizontalFieldLayout,
    SelectField
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    day: {
      type: Number,
      default: 14
    },
    hour: {
      type: Number,
      default: 15
    },
    enabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:day',
    'update:hour',
    'update:enabled'
  ],
  computed: {
    innerDay: {
      get () {
        return this.day
      },
      set (value) {
        this.$emit('update:day', value)
      }
    },
    innerHour: {
      get () {
        return this.hour
      },
      set (value) {
        this.$emit('update:hour', value)
      }
    },
    innerEnabled: {
      get () {
        return this.enabled
      },
      set (value) {
        this.$emit('update:enabled', value)
      }
    },
    hours () {
      return [
        {
          value: 7,
          text: '07:00'
        },
        {
          value: 8,
          text: '08:00'
        },
        {
          value: 9,
          text: '09:00'
        },
        {
          value: 10,
          text: '10:00'
        },
        {
          value: 11,
          text: '11:00'
        },
        {
          value: 12,
          text: '12:00'
        },
        {
          value: 13,
          text: '13:00'
        },
        {
          value: 14,
          text: '14:00'
        },
        {
          value: 15,
          text: '15:00'
        },
        {
          value: 16,
          text: '16:00'
        },
        {
          value: 17,
          text: '17:00'
        },
        {
          value: 18,
          text: '18:00'
        },
        {
          value: 19,
          text: '19:00'
        },
        {
          value: 20,
          text: '20:00'
        },
        {
          value: 21,
          text: '21:00'
        },
        {
          value: 22,
          text: '22:00'
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>
